import Typography from "@mui/material/Typography";
import type { SearchTemplateValue } from "../../api/";
import { AttentionBadge } from "./AttentionBadge";
import { BaseTodoBox } from "./BaseTodoBox";
import { TodoTag } from "./TodoTag";
import { setClassNamesByCount } from "./utils";

export const StaleConversations = ({
	staleConversationsCorona,
	readOnly = false,
	type,
}: {
	staleConversationsCorona: SearchTemplateValue;
	readOnly?: boolean;
	type?: string;
}) => {
	return (
		<BaseTodoBox
			className={setClassNamesByCount(staleConversationsCorona.count)}
			title={
				<AttentionBadge
					count={staleConversationsCorona.count}
					title="Stale conversations"
					readOnly={readOnly}
					url={staleConversationsCorona.url}
				/>
			}
			description={
				<>
					<Typography variant="body1" component="div" color="textPrimary">
						Respond or set <TodoTag>vi-tackat-nej</TodoTag> or set{" "}
						<b>reminder</b>
					</Typography>
				</>
			}
		/>
	);
};

export const StaleConversationsLeads = ({
	staleConversations,
	readOnly = false,
}: {
	staleConversations: SearchTemplateValue;
	readOnly?: boolean;
}) => {
	return (
		<BaseTodoBox
			className={setClassNamesByCount(staleConversations.count)}
			title={
				<AttentionBadge
					count={staleConversations.count}
					title="Stale conversations that are leads"
					readOnly={readOnly}
					url={staleConversations.url}
				/>
			}
			description={
				<Typography variant="body1" component="div" color="textPrimary">
					Set <b>reminder</b> or set one of the tags{" "}
					<TodoTag>artemis-tackar-nej</TodoTag>{" "}
					<TodoTag>artemis-bokad-intervju</TodoTag> to remove person from list
				</Typography>
			}
			to={staleConversations.url}
			readOnly={readOnly}
		/>
	);
};
